import { REDUCER_KEY } from "./card.constants";
export var isMarkingAllAsReadSelector = function (state) {
    return state[REDUCER_KEY] ? state[REDUCER_KEY].cards.isPending : false;
};
export var markAllAsReadError = function (state) {
    return state[REDUCER_KEY] ? state[REDUCER_KEY].cards.error : undefined;
};
